import { render } from "./MediaflowContent.vue?vue&type=template&id=0cb105cc"
import script from "./MediaflowContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowContent.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowContent.vue?vue&type=style&index=0&id=0cb105cc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/MediaflowDash/MediaflowContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cb105cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cb105cc', __exports__)) {
    api.reload('0cb105cc', __exports__)
  }
  
  module.hot.accept("./MediaflowContent.vue?vue&type=template&id=0cb105cc", () => {
    api.rerender('0cb105cc', render)
  })

}


export default __exports__